module.exports = __webpack_public_path__ + "img/43.421627fe.jpeg";